import {atom} from 'recoil';
import allTypes from '../../types/allinclusive';

export const all = atom<allTypes>({
  key: 'all',
  default: undefined,
});
